import * as React from 'react';

interface ChatLogoProps {
    className?: string;
    color?: string;
}

export default function CloseIcon({ className, color = '#FFF' }: ChatLogoProps) {
    return (
        <svg version="1.1" viewBox="0 0 32 32" className={className} xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="22" width="24" height="2" fill={color}/>
        </svg>
    );
}
